import groq from 'groq'

import { frameBuilderImageFragment } from './image'

const frameBuilderSettingsFragment = groq`
  backboardSku,
  noPassepartoutSku,
  minimumPassepartoutSize,
  maximumPassepartoutSize,
  largeFormatWeightBonus,
  noOptionImage {
    ${frameBuilderImageFragment}
  },
`

const frameBuilderProductSettingsFragment = groq`
  backboardSku,
  noPassepartoutSku,
  minimumPassepartoutSize,
  maximumPassepartoutSize,
  largeFormatWeightBonus,
`

export const frameBuilderSettingsObjectFragment = groq`
  "settings": *[
    _type == "frameBuilderSettings" &&
    locale == $locale
  ][0] {
    ${frameBuilderSettingsFragment}
  },
`

export const frameBuilderProductSettingsObjectFragment = groq`
  "settings": *[
    _type == "frameBuilderSettings" &&
    locale == $locale
  ][0] {
    ${frameBuilderProductSettingsFragment}
  },
`
